<template>

<div class="content-list-wrapper">

	<div class="content-list" ref="list" v-bind:class="{'is-flush': flush, 'can-wide': canWide, 'is-selecting': selectActive, 'is-fixed': fixed, 'is-full': full, 'is-cards': cards}" v-on:scroll="onScroll">

		<div class="content-list-offset is-top" v-observe-visibility="{callback: onTopVisibilityChange, intersection: { rootMargin: ($isMobile) ? '-80px 0px 0px 0px' : '-64px 0px 0px 0px' }}"></div>

		<slot></slot>

		<div class="content-list-offset is-bottom" v-observe-visibility="onBottomVisibilityChange"></div>

	</div>

	<div class="content-shade is-left" :class="{'is-active': scrollLeft > 0}" />
	<div class="content-shade is-right" :class="{'is-active': scrollLeft < maxScrollLeft}" />

</div>

</template>

<script>

export default {

	props: ['flush', 'full', 'cards', 'canWide', 'fixed'],

	data: function() {
	
		return {
			topVisible: false,
			bottomVisible: false,
			scrollLeft: 0,
			scrollWidth: 0,
			clientWidth: 0,

			// internal observers
			ro: null,
			mo: null,
			raf: 0
		}

	},

	mounted: function() {

		// once refs exist, set up observers and take initial measurement
		this.setupObservers()

		this.$nextTick(function() {

			this.scheduleMeasure()

		}.bind(this))

		window.addEventListener('resize', this.scheduleMeasure, { passive: true })

	},

	beforeDestroy: function() {

		window.removeEventListener('resize', this.scheduleMeasure)

		if (this.ro) this.ro.disconnect()
		if (this.mo) this.mo.disconnect()

		if (this.raf) cancelAnimationFrame(this.raf)

	},

	computed: {

		selectActive: function() {

			return this.$store.getters['service/select/count']

		},

		maxScrollLeft: function() {

			return Math.max(0, this.scrollWidth - this.clientWidth)

		}

	},

	methods: {

		// read DOM and sync reactive state
		measure: function() {

			var el = this.$refs.list

			if (!el) return

			this.scrollLeft = el.scrollLeft
			this.scrollWidth = el.scrollWidth
			this.clientWidth = el.clientWidth

		},

		// coalesce multiple updates into one rAF tick (+ nextTick for Vue DOM flush)
		scheduleMeasure: function() {

			if (this.raf) cancelAnimationFrame(this.raf)

			this.raf = requestAnimationFrame(function() {

				this.raf = 0

				this.$nextTick(function() {

					this.measure()

				}.bind(this))

			}.bind(this))

		},

		setupObservers: function() {

			var el = this.$refs.list

			if (!el) return

			// ResizeObserver catches layout/clientWidth/scrollWidth changes (fonts, images, responsive, etc)
			if (window.ResizeObserver) {

				this.ro = new ResizeObserver(function() {

					this.scheduleMeasure()

				}.bind(this))

				this.ro.observe(el)

			}

			// MutationObserver catches slot DOM changes (async load, v-if, list updates, etc)
			this.mo = new MutationObserver(function() {

				this.scheduleMeasure()

			}.bind(this))

			this.mo.observe(el, { childList: true, subtree: true })

		},
	
		onScroll: function(e) {

			this.scrollLeft = e.target.scrollLeft
			this.scrollWidth = e.target.scrollWidth
			this.clientWidth = e.target.clientWidth

			if (this.window.is.mobile) this.$emit('scrollleft', e.target.scrollLeft)

		},

		onTopVisibilityChange: function(visible) {

			this.topVisible = visible
			this.$emit('fixed', !this.topVisible)

			// visibility shifts can affect layout
			this.scheduleMeasure()
		
		},
	
		onBottomVisibilityChange: function(visible) {
		
			this.bottomVisible = visible

			// bottom visibility changes can affect layout
			this.scheduleMeasure()

		}

	}

}

</script>

<style scoped>

.is-mobile .content-list-wrapper {
	overflow: hidden;
}

.is-mobile .content-list.can-wide {
	overflow-x: auto;
	overflow-y: hidden;
}

.content-list-offset {
	right: 0px;
	height: 32px;
	position: absolute;
	left: 0px;
	pointer-events: none;
}

.content-list-offset.is-top {
	top: -64px;
}

.is-mobile .content-list-offset.is-top {
	top: -32px;
}

.content-list-offset.is-bottom {
	bottom: -32px;
}

.is-mobile .content-list:not(.is-cards),
.is-smaller .content-list:not(.is-cards),
.is-desktop .content-list:not(.is-cards),
.is-tablet .content-list:not(.is-cards) {
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 0px 0px 4px 4px;
}

.content-list.is-fixed {
	margin-top: 32px;
}

.content-list.is-cards {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
	grid-gap: 20px;
}

.is-tablet .content-list.is-cards {
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.is-mobile .content-list.is-cards {
	grid-template-columns: minmax(0, 1fr);
	grid-gap: 10px;
}

.is-mobile .content-shade {
	position: absolute;
	top: 0px;
	bottom: 0px;
	opacity: 0;
	background-color: transparent;
	width: 10px;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.content-shade.is-active {
	opacity: 1;
}

.is-mobile .content-shade.is-left {
	left: -20px;
	transition: left 100ms linear;
}

.content-shade.is-active.is-left  {
	left: -10px;
}

.is-mobile .content-shade.is-right {
	right: -20px;
	transition: right 100ms linear;
}

.content-shade.is-active.is-right  {
	right: -10px;
}

</style>
